import { createFileRoute } from "@tanstack/react-router";
import { TicketReport } from "@/features/tickets/TicketReport";

export const Route = createFileRoute("/_authenticated/reports/ticket-sla-breach")({
  component: () => (
    <TicketReport
      id="R-46"
      title="SLA Breach Report"
      description="Tickets that have breached response or resolution SLA."
      baseFilters={{ slaBreachedOnly: true }}
      enabledFilters={["branch", "department", "priority", "coverage", "dateRange"]}
      filename="ticket-sla-breach"
    />
  ),
});
